export default {
  donnees_pending: false,
  donnees: []
}
